import React from "react";

interface AnimatedRequirementProps {
  text: string;
  isMet: boolean;
}

const AnimatedRequirement: React.FC<AnimatedRequirementProps> = ({
  text,
  isMet,
}) => {
  return (
    <span className="relative inline font-semibold text-on-surface-primary">
      {text}
      <span
        className="absolute left-0 top-1/2 h-[1px] bg-on-surface-primary transition-[width] duration-300 ease-out"
        style={{ width: isMet ? "100%" : "0%" }}
      />
    </span>
  );
};

interface PasswordRequirementsTextProps {
  password: string;
}

export const PasswordRequirementsText: React.FC<
  PasswordRequirementsTextProps
> = ({ password }) => {
  const hasLength = password.length >= 8;
  const hasNumbers = /\d/.test(password);
  const hasSpecialChars = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  return (
    <p className="text-[13px] font-normal leading-[17px] text-on-surface-muted">
      Your password must be at least{" "}
      <AnimatedRequirement text="8 characters" isMet={hasLength} />, include{" "}
      <AnimatedRequirement text="numbers" isMet={hasNumbers} /> and{" "}
      <AnimatedRequirement text="special characters" isMet={hasSpecialChars} />{" "}
      to make it more secure.
    </p>
  );
};
